import { compact, omit } from 'lodash-es';
import { createComponentPath } from 'site-modules/personalized-search/utils/create-component-path';
import {
  ALWAYS_RENDERED_COMPONENTS,
  SUPPORTED_COMPONENTS,
} from 'site-modules/personalized-search/constants/supported-components';

export function generateComponentsPaths(data) {
  const result = {};
  const orderedPaths = [];

  function generateComponentPath(parentComponentName, componentData, order) {
    componentData.components.forEach(component => {
      if (!omit(SUPPORTED_COMPONENTS, ALWAYS_RENDERED_COMPONENTS)[component]) return;

      const path = createComponentPath(parentComponentName, component, order);

      result[path] = false;
      orderedPaths.push(path);

      if (componentData[component]) {
        // eslint-disable-next-line no-use-before-define
        recursiveBuilder(path, componentData[component]);
      }
    });
  }

  function recursiveBuilder(parentComponentName, componentData) {
    if (Array.isArray(componentData)) {
      componentData.forEach((item, index) => {
        if (!item.components) {
          return;
        }

        generateComponentPath(parentComponentName, item, index + 1);
      });
    } else {
      if (!componentData?.components) {
        return;
      }
      generateComponentPath(parentComponentName, componentData);
    }
  }

  recursiveBuilder('', data);

  return { result, orderedPaths: compact(orderedPaths) };
}
